export default function queryConcatenator(url, queryObj) {
  return Object.entries(queryObj).reduce(
    (urlString, [query, value]) => `${urlString}${query}=${value}&`,
    url
  );
}
